// src/publicuser/components/LearningSideBar.jsx
import React from 'react';
import '../../css/LearningSideBar.css';

const LearningSideBar = ({ posts, selectedPost, onPostSelect, isMobileOpen }) => {
  return (
    <aside className={`learn-sidebar ${isMobileOpen ? 'learn-mobile-visible' : ''}`}>
      <div className="learn-sidebar-header">
        <div className="learn-sidebar-title">
          <span className="learn-sidebar-icon">📚</span>
          <h3>{selectedPost?.category} Tutorials</h3>
          {/* <h3> {posts && posts.length > 0   ? `${posts[0]?.category} Tutorial`   : 'No Tutorials Available' }
          </h3> */}
        </div>
        <span className="learn-post-count">{posts.length} lessons</span>
      </div>
      
      <div className="learn-sidebar-content">
        {posts.length === 0 ? (
          <div className="learn-no-posts">
            <span className="learn-no-posts-icon">📖</span>
            <p>No tutorials available in this category yet.</p>
          </div>
        ) : (
          <ul className="learn-post-list">
            {posts.map((post, index) => (
              <li key={post.id}>
                <button
                  className={`learn-post-item ${selectedPost?.id === post.id ? 'learn-active' : ''}`}
                  onClick={() => onPostSelect(post)}
                >
                  <span className="learn-post-number">{String(index + 1).padStart(2, '0')}</span>
                  <span className="learn-post-title">{post.title}</span>
                  {selectedPost?.id === post.id && (
                    <span className="learn-active-indicator">▶</span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </aside>
  );
};

export default LearningSideBar;